export enum PosPaymentGroupEnum{
    External_Payment = 1,
    Integrated_Payments = 2,
    Split_Payment = 3
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/pos-payment-group.enum.ts